export default __webpack_public_path__ + "static/media/rahel.41bb5945.jpg";